import React from 'react'
import { useIntl } from 'hooks'
import { RadioButton, RadioButtonGroup } from 'components/Zui'

const CollectionSort = ({ initialValue, onChange }) => {
    const { t } = useIntl()

    const options = [
        { label: t('modified.desc'), value: 'dateDesc' },
        { label: t('modified.asc'), value: 'dateAsc' },
        { label: t('az'), value: 'az' },
        { label: t('za'), value: 'za' },
    ]
    return (
        <div style={{ width: '176px' }}>
            <RadioButtonGroup
                name="sort"
                value={initialValue}
                onChange={e => onChange(e.target.value)}
            >
                {options.map(option => {
                    const { value, label } = option
                    return <RadioButton key={value} label={label} value={value}></RadioButton>
                })}
            </RadioButtonGroup>
        </div>
    )
}

export default React.memo(CollectionSort)
